import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../src/index.css';
import Login from "./components/auth/Login";
import AuthCallback from "./pages/AuthCallback";
import OrganizationsSelection from "./pages/OrganizationsSelection";
import Dashboard from "./pages/Dashboard";
import POSInterface from "./pages/Cashier/POSInterface";
import CashierHomeScreen from "./pages/Cashier/CashierHomeScreen";
import CashierCustomersPage from "./pages/Cashier/CashierCustomersPage";
import CashierCustomerDetailPage from "./pages/Cashier/CashierCustomerDetailPage";
import CashierPaymentRequestsPage from "./pages/Cashier/CashierPaymentRequestsPage";
import CashierPaymentLinksPage from "./pages/Cashier/CashierPaymentLinksPage";
// import CashierInvoicesPage from "./pages/Cashier/CashierInvoicesPage"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
import CashierReportsPage from "./pages/Cashier/CashierReportsPage";
// import CashierArticlesPage from "./pages/Cashier/CashierArticlesPage"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
// import CashierArticleDetailPage from "./pages/Cashier/CashierArticleDetailPage"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
import CashierTransactionsPage from "./pages/Cashier/CashierTransactionsPage";
import CashierProfilePage from "./pages/Cashier/CashierProfilePage";
import PaymentScan from "./pages/Customer/PaymentScan";
import CaisseManagement from "./pages/Admin/CaisseManagement";
import ClientManagement from "./pages/Admin/ClientManagement";
// import ArticleManagement from "./pages/Admin/ArticleManagement"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
// import ArticleDetailPage from "./pages/Admin/ArticleDetailPage"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
import PaymentLinks from "./pages/Admin/PaymentLinks";
import RolesPermissions from "./pages/Admin/RolesPermissions";
import UserManagement from "./pages/Admin/UserManagement";
import PaymentManagement from "./pages/PaymentManagement";
// import Invoicing from "./pages/Admin/Invoicing"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
// import InvoiceDetailsPage from "./pages/Admin/InvoiceDetailsPage"; // Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
import Reports from "./pages/Admin/Reports";
import Settings from "./pages/Admin/Settings";
import PaymentRequests from "./pages/Admin/PaymentRequest";
import WithdrawalPage from "./pages/Admin/WithdrawalPage";
import OrganizationsPage from "./pages/Admin/OrganizationsPage";
import TransactionsPage from "./pages/Admin/TransactionsPage";
import NotificationsPage from "./pages/Admin/NotificationsPage";
import Landing from "./pages/Landing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import {AuthProvider, ProtectedRoute} from "./contexts/AuthContext";
import {PaymentProvider} from "./contexts/PaymentContext";
import {NotificationProvider} from "./contexts/NotificationContext";
import {CurrencyProvider} from "./contexts/CurrencyContext";
import {XhrProvider} from "./contexts/XhrContext";
import {SharedDataProvider} from "./contexts/SharedDataContext";

function App() {
  return (
      <Router>
          <AuthProvider>
              <XhrProvider>
                  <SharedDataProvider>
                      <CurrencyProvider>
                          <NotificationProvider>
                              <PaymentProvider>
        <div className="App">
          <main>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/auth/organizations" element={<OrganizationsSelection />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                          <Route
                              path="/dashboard"
                              element={
                                  <ProtectedRoute>
                                      <Dashboard />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/pos"
                              element={
                                  <ProtectedRoute>
                                      <POSInterface />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier"
                              element={
                                  <ProtectedRoute>
                                      <CashierHomeScreen />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier/customers"
                              element={
                                  <ProtectedRoute>
                                      <CashierCustomersPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier/customers/:id"
                              element={
                                  <ProtectedRoute>
                                      <CashierCustomerDetailPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier/payment-requests"
                              element={
                                  <ProtectedRoute>
                                      <CashierPaymentRequestsPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier/payment-links"
                              element={
                                  <ProtectedRoute>
                                      <CashierPaymentLinksPage />
                                  </ProtectedRoute>
                              }
                          />
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/cashier/invoices"
                              element={
                                  <ProtectedRoute>
                                      <CashierInvoicesPage />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/cashier/articles"
                              element={
                                  <ProtectedRoute>
                                      <CashierArticlesPage />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/cashier/articles/:id"
                              element={
                                  <ProtectedRoute>
                                      <CashierArticleDetailPage />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          <Route
                              path="/cashier/reports"
                              element={
                                  <ProtectedRoute>
                                      <CashierReportsPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier/transactions"
                              element={
                                  <ProtectedRoute>
                                      <CashierTransactionsPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/cashier/profile"
                              element={
                                  <ProtectedRoute>
                                      <CashierProfilePage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/pay"
                              element={
                                  <ProtectedRoute>
                                      <PaymentScan />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/payments"
                              element={
                                  <ProtectedRoute>
                                      <PaymentManagement />
                                  </ProtectedRoute>
                              }
                          />
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/admin/articles"
                              element={
                                  <ProtectedRoute>
                                      <ArticleManagement />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/admin/articles/:id"
                              element={
                                  <ProtectedRoute>
                                      <ArticleDetailPage />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          <Route
                              path="/admin/clients"
                              element={
                                  <ProtectedRoute>
                                      <ClientManagement />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/caisses"
                              element={
                                  <ProtectedRoute>
                                      <CaisseManagement />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/users"
                              element={
                                  <ProtectedRoute>
                                      <UserManagement />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/payment-links"
                              element={
                                  <ProtectedRoute>
                                      <PaymentLinks />
                                  </ProtectedRoute>
                              }
                          />
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/admin/invoices"
                              element={
                                  <ProtectedRoute>
                                      <Invoicing />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          {/* Factures / Articles masqués pour la mise en dev : décommenter pour réactiver
                          <Route
                              path="/admin/invoices/:id"
                              element={
                                  <ProtectedRoute>
                                      <InvoiceDetailsPage />
                                  </ProtectedRoute>
                              }
                          />
                          */}
                          <Route
                              path="/admin/reports"
                              element={
                                  <ProtectedRoute>
                                      <Reports />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/settings"
                              element={
                                  <ProtectedRoute>
                                      <Settings />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/payment-requests"
                              element={
                                  <ProtectedRoute>
                                      <PaymentRequests />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/roles"
                              element={
                                  <ProtectedRoute>
                                      <RolesPermissions />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/WithdrawalPage"
                              element={
                                  <ProtectedRoute>
                                      <WithdrawalPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/organizations"
                              element={
                                  <ProtectedRoute>
                                      <OrganizationsPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="admin/transactions"
                              element={
                                  <ProtectedRoute>
                                      <TransactionsPage />
                                  </ProtectedRoute>
                              }
                          />
                          <Route
                              path="/admin/notifications"
                              element={
                                  <ProtectedRoute>
                                      <NotificationsPage />
                                  </ProtectedRoute>
                              }
                          />
            </Routes>
          </main>
        </div>
                          </PaymentProvider>
                      </NotificationProvider>
                  </CurrencyProvider>
              </SharedDataProvider>
              </XhrProvider>
          </AuthProvider>
      </Router>
  );
}

export default App;